import { LanguageType } from '../index.js'
import {
  humberOfHomesTranslation,
  initiativeCreationStepDescriptionTranslation,
  initiativeCreationStepTitleTranslation,
  initiativePhaseDescriptionTranslation,
  initiativePhaseNameTranslation,
  initiativeUserRoleTranslation,
  notificationFrequencyTranslation,
  phaseTranslations,
  plotApplicationStatusesTranslations,
} from './en.enumTranslations.js'

const shared = {
  ambassador: 'Ambassador',
  ambassadors: 'Ambassadors',
  experts: 'Experts',
  crowdBuilding: 'CrowdBuilding',
  contactUsLink: 'Contact',
  knowledgeHub: 'Knowledge Hub',
  storiesLink: 'Stories',
  initiative: {
    singular: 'Initiative',
    plural: 'Initiatives',
  },
  location: {
    singular: 'Location',
    plural: 'Locations',
  },
  housingForms: 'Living formats',
  sendMessage: 'Send message',
  back: 'Back',
  yes: 'Yes',
  no: 'No',
  noPreference: 'No preference',
  external: 'External',
  messages: 'Messages',
  purchaseBudget: 'Purchase budget',
  rentalBudget: 'Rental budget',
  loading: 'Loading...',
  unknownLocation: 'Unknown location',
  unknown: 'Unknown',
  notSpecified: 'Not Specified',
  members: 'Members',
  followers: 'Followers',
  follow: 'Follow',
  following: 'Following',
  admins: 'Admins',
  followTooltip: 'Follow for updates',
  signUp: 'Sign up',
  lockedPageFollowed: 'You are following this page',
  lockedPageFollowedText:
    'Once it goes live you will be among the first people who will get notified.',
  attention: 'Attention',
  cancel: 'Cancel',
}

const en: LanguageType = {
  app: {
    badges: {
      initiativeTaker: 'Initiative taker',
    },
    knowledgeHubTab: {
      title: shared.knowledgeHub,
      noModules: 'No knowledge modules linked.',
    },
    blogPage: {
      title: 'Latest',
      description:
        'Stories, news and updates about collective building and community living on CrowdBuilding.',
      loading: shared.loading,
      tabs: {
        stories: 'Stories',
        news: 'News',
        blog: 'Blog',
        agenda: 'Agenda',
      },
      noContent: 'No content found',
    },
    eventsPage: {
      title: 'Events',
      description:
        'Events, meetups and workshops about collective building and community living.',
    },
    businessProfilePage: {
      address: 'Address',
      email: 'E-mail',
      phone: 'Phone number',
      website: 'Website',
      specializations: 'Specialised in',
    },
    common: {
      yes: 'Yes',
      no: 'No',
      other: 'Other',
      cancel: shared.cancel,
      save: 'Save',
      back: 'Back',
      continue: 'Continue',
      attention: shared.attention,
      note: 'Note:',
      seeMore: 'See all',
      hide: 'Hide',
      readMore: 'Read more',
      readLess: 'Read less',
      unknownLocation: shared.unknownLocation,
      initiative: {
        singular: 'Initiative',
        plural: 'Initiatives',
      },
      share: 'Share',
      banner: 'Banner',
      follow: 'Follow',
      followTooltip: shared.followTooltip,
      unfollow: 'Unfollow',
      following: shared.following,
      contact: 'Contact',
      followers: 'Followers',
      followersAmount: '{0} followers',
      notSpecified: shared.notSpecified,
      initiativePhases: phaseTranslations,
      initiativeStatus: {
        searchingForMembers: 'Looking for members',
        notSearchingForMembers: 'Not looking for members',
      },
      plotApplicationStatus: plotApplicationStatusesTranslations,
      initiativeUserRole: initiativeUserRoleTranslation,
      loading: shared.loading,
      more: 'More',
      less: 'Less',
      location: 'Location',
      locationNotFoundMessage: 'Location not found',
      region: 'Region',
      regionNotFoundMessage: 'Region not found',
      toastSuccess: 'Success!',
      toastFailure: 'Something went wrong',
      genericToastFailureMessage:
        'Please, try again. If problem persists contact CrowdBuilding.',
      sendMessage: shared.sendMessage,
      unknown: shared.unknown,
      noItems: 'No items found',
      filtersTooltip: 'Filters',
      signUp: shared.signUp,
    },
    auth: {
      logIn: 'Log in',
      signUp: shared.signUp,
      logInTitle: 'Welcome back!',
      signUpTitle: 'Sign up with CrowdBuilding',
      signUpSubtitle: 'Sign up for free.',
      shareMoreTitle: 'Share something about yourself',
      shareMoreSubtitle:
        'This will help you find people and initiatives that suit you more quickly.',
      email: 'Email',
      emailPlaceholder: 'Fill in your email address...',
      emailSubtitle:
        'You will receive a confirmation code at this email address to log in.',
      privacySubtitle: 'By signing up you agree to our',
      privacySubtitleAnd: 'and',
      privacyStatementLink: 'privacy statement',
      termsAndConditionsLink: 'general terms and conditions',
      privacyStatementTitle: 'CrowdBuilding Privacy Statement',
      termsAndConditionsTitle: 'General Terms and Conditions',
      firstName: 'First name',
      firstNamePlaceholder: 'First name',
      lastName: 'Last name',
      lastNamePlaceholder: 'Last name',
      placeOfResidence: 'Place of residence',
      ageCategory: 'Age category',
      ageCategoryPlaceholder: 'Choose one...',
      searchRegion: 'Search region',
      searchRegionPlaceholder: 'Where would you like to live?',
      continueWithGoogle: 'Continue with Google',
      continueWithApple: 'Continue with Apple',
      loginButton: 'Log in',
      signUpButton: 'Create an account',
      verificationCodeBanner:
        'You have received a verification code in your email',
      verificationLabel: 'Verification code',
      emailInvalidMessage: 'Check your email and try again.',
      emailIssueNoUserMessage: 'User with this email does not exist',
      emailIssueUserExistsMessage: 'User with this email already exists',
      emailIssueOtherMessage: 'Something went wrong',
      otcIssueMessage:
        'Incorrect 2FA code. Please try again or request a new code.',
      nameInvalidMessage: 'Cannot be empty',
      otherIssueMessage: 'Something went wrong. Please, try again.',
      sendCodeAgain: 'Send code again',
      alreadyLoggedIn: 'You are already logged in.',
    },
    discoveryPage: {
      initiatives: 'Initiatives',
      plots: 'Locations',
      regions: 'Regions',
      housingForms: 'Living formats',
      searchResults: {
        singular: 'result',
        plural: 'results',
      },
      searchPlaceholder: {
        mobile: 'Search',
        initiatives: 'Search by name, municipality or province',
        plots: 'Search by name, municipality or province',
        regions: 'Search by name of your town, municipality or province',
        housingForms: 'Search by keyword',
      },
      searchSuggestions: {
        locality: 'Place in {0}',
        municipality: 'Municipality in {0}',
        region: 'Province in {0}',
      },
      filterDrawer: {
        title: 'Filters',
        phase: 'Phase',
        applicationStatus: 'Phase',
        lookingForMembers: 'Looking for members',
        developmentForm: 'Development form',
        province: 'Province',
        applicationType: 'Application type',
        apply: 'Apply',
        back: 'Back',
        initiativePhases: phaseTranslations,
        plotApplicationStatuses: plotApplicationStatusesTranslations,
        yes: 'Yes',
        no: 'No',
        noPreference: 'No preference',
        external: 'External',
        crowdBuilding: 'CrowdBuilding',
        externalTooltip: 'Initiatives that are made by external websites.',
        crowdBuildingTooltip: 'Initiatives that are made by CrowdBuilding.',
      },
      tabs: {
        initiatives: {
          title: 'Discover initiatives',
          subTitle: 'Find your dream home here.',
          spotlight: {
            title: 'Featured initiatives',
            subTitle: 'These featured initiatives are looking for new members.',
          },
          emptyTitle: 'No initiatives found',
          emptyDescription:
            "Try adjusting your search or filter criteria to find what you're looking for.",
        },
        plots: {
          title: 'Discover locations',
          subTitle: 'Find your dream home here.',
          mapTitle: {
            singular: 'There is {0} initiative',
            plural: 'There are {0} initiatives',
          },
          emptyTitle: 'No plots found',
          emptyDescription:
            "Try adjusting your search or filter criteria to find what you're looking for.",
          spotlight: {
            title: 'Featured locations',
            subTitle: 'Check out the featured plots and buildings.',
          },
        },
        regions: {
          provinceTitle: 'Discover regions',
          provinceSubTitle:
            'Learn how your province can help you realize your dream.',
          municipalitesTitle: 'All municipalities',
          municipalitesSubtitle:
            'Discover what is happening in the field of building and living together.',
          featuredMunicipalitesTitle: 'Featured',
          featuredMunicipalitesSubtitle:
            'View the latest news, policy, initiatives and locations in these popular municipalities.',
          emptyTitle: 'No regions found',
          emptyDescription:
            "Try adjusting your search or filter criteria to find what you're looking for.",
        },
        housingForms: {
          title: 'Discover housing forms',
          subtitle:
            'Discover different themes within collective building and living.',
          emptyTitle: 'No housing forms found',
          emptyDescription:
            "Try adjusting your search to find what you're looking for.",
        },
      },
    },
    housingFormPage: {
      loading: shared.loading,
      follow: shared.follow,
      following: shared.following,
      ambassador: shared.ambassador,
      ambassadorCard: {
        title: shared.ambassador,
      },
      popularHousingFormsCard: {
        title: 'Popular housing forms',
      },
      noExpertsTitle: 'No experts yet',
      noInitiativesTitle: 'Be the first',
      noInitiativesCta: 'Start initiative',
      noInitiativesDescription: 'Be the first, create your initiative',
      noLocationsTitle: 'No matching locations yet',
      noLocationsDescription: 'Register a building or plot yourself.',
      tabs: {
        overview: 'Overview',
        thread: 'Discussion',
        initiatives: 'Initiatives',
        plots: 'Locations',
        experts: shared.experts,
        popularHousingForms: 'Popular housing forms',
        knowledgeHub: shared.knowledgeHub,
        current: 'Current',
      },
      pageTabTitle: {
        overview: '',
        thread: '{0} discussion',
        initiatives: '{0} initiatives',
        plots: '{0} locations',
        knowledgeHub: '{0} knowledge hub',
        current: '{0} news',
        popularHousingForms: 'Popular housing forms',
        experts: '{0} experts',
      },
    },
    topicCommunityPage: {
      loading: shared.loading,
      follow: shared.follow,
      following: shared.following,
      managedBy: 'Managed by',
      featuredInitiatives: 'Featured initiatives',
      noKnowledgeHubModules: 'No knowledge hub modules available.',
      relatedHousingFormsCard: {
        title: 'Housing forms',
      },
      networksCard: {
        title: 'Networks',
      },
      tabs: {
        overview: 'Overview',
        thread: 'Discussion',
        initiatives: 'Initiatives',
        knowledgeHub: shared.knowledgeHub,
        contactInfo: 'Contact',
        events: 'Agenda',
      },
      noContact: 'No contact information available.',
      noEvents: 'No events linked.',
      municipality: 'Municipality',
      knowledgeBank: 'Knowledge bank',
    },
    legalPage: {
      title: 'Legal Documents',
      description: 'General terms and conditions and privacy policy.',
      termsAndConditionsDownloadTitle: 'Terms and Conditions',
      privacyPolicyDownloadTitle: 'Privacy Policy',
      cookiePolicyDownloadTitle: 'Cookie Policy',
      downloadButtonLabel: 'Download PDF',
    },
    aboutUsPage: {
      title: 'A fair and sustainable housing system',
      description:
        'How we contribute to a fair and sustainable housing market.',
      hero2ImageAlt: 'Photo of floating houses',
    },
    contactPage: {
      title: shared.contactUsLink,
      description:
        'Have a question? Contact CrowdBuilding support, our press team, or visit our office in Amsterdam.',
    },
    stewardOwnershipPage: {
      title: 'CrowdBuilding is steward-owned',
      description:
        'Our mission is central and legally protected. Steward-ownership keeps profit in service of social impact.',
    },
    forExpertsPage: {
      title: 'For experts',
      description:
        'CrowdBuilding is looking for professional partners across the Netherlands who share our vision for collective housing.',
    },
    rabobankLandingPage: {
      title: 'CPO desk in your region',
      description:
        'Planning to start a CPO project with your group? Rabobank is happy to help you move forward.',
    },
    regionCard: {
      initiatives: {
        singular: 'initiative',
        plural: 'initiatives',
      },
      subsidies: {
        singular: 'subsidy',
        plural: 'subsidies',
      },
      plots: {
        singular: 'plot',
        plural: 'plots',
      },
    },
    knowledgeHubPage: {
      title: 'Knowledge Hub',
      description:
        'Here you will find all the information you need to make your living dream a reality.',
      loading: 'Loading...',
      menu: 'Knowledge Hub Menu',
      searchPlaceholder: 'Search',
      noResults: 'No results found',
      noArticlesTitle: 'No articles found',
      noArticlesDescription:
        'Adjust your filters or search term and try again.',
      back: shared.back,
    },
    elearningPage: {
      sidebarTitle: 'Curriculum',
      searchPlaceholder: 'Search',
      title: 'Learning environment',
      description:
        'Modules and assignments to develop your housing initiative step by step with your group.',
      loading: 'Loading...',
      menu: 'Learning environment Menu',
      previous: 'Previous',
      next: 'Next',
      selectItem: 'Select an item from the menu',
      viewSlides: 'View the slides',
      viewSlidesDesc:
        'Do you want to view the presentation again at your own pace? View the slideshow below. You can also download and print the presentation.',
      assignments: 'Assignments for the modules',
      assignmentsDesc1:
        'At the end of each module you can download an assignment form. It contains questions for you and an assignment that you do together with your group.',
      assignmentsDesc2:
        'The questions you fill in yourself are intended to organize your own thoughts. Then you can discuss your vision and your housing dream well prepared with other group members. This way you come a step closer to a concrete plan for your initiative every module.',
      tip: 'Tip: Stichting !WOON regularly organizes in-depth training courses to develop your vision, mission, plan of approach and financial business plan in group form. Do you want to know more about this? Check our agenda for these training courses.',
      downloadPdfLabel: 'Download PDF',
    },
    forMunicipalities: {
      hero: {
        badge: 'For municipalities with land',
        title: 'You have plots, but no process',
        description:
          'Then you have come to the right place. CrowdBuilding helps municipalities with a proven process to issue plots for collective housing. Fair, efficient and without extra pressure on your colleagues. Are you responsible for the housing file in your municipality? Read here how we can help you.',
      },
      residentTestimonials: {
        title: 'Residents tell',
        intro:
          'These are the people for whom you do it. Their story started with a municipality that said yes.',
      },
      partners: {
        title: 'Already works for:',
      },
      painPoints: {
        title: 'Pain points',
        intro:
          'In our conversations with Housing policy officers, we often hear the same things. The ambition for collective housing is there – but time, overview, the right knowledge and the process are missing.',
        items: {
          noTime: {
            title: 'No time for group guidance',
            description:
              "There is policy, but no capacity. Guiding groups takes time you don't have.",
          },
          enoughInitiatives: {
            title: 'Are there enough initiatives?',
            description:
              "Groups register - but you don't know how many there are, how serious they are, or what they need to get further.",
          },
          noProcess: {
            title: 'Plots, but no process',
            description:
              'You want to issue plots for collective housing, but a standardized selection process is missing.',
          },
          noExpertise: {
            title: 'Too little expertise in-house',
            description:
              'Facilitating collective housing requires specific knowledge that is not in your own team. You need a partner who knows the process.',
          },
        },
      },
      solutions: {
        title: 'Solutions',
        subtitle: 'What CrowdBuilding offers',
        intro:
          'CrowdBuilding aligns with your existing policy and processes. No extra pressure on your team, but direct results and insight.',
        groupGuidance: {
          badge: 'Group formation',
          title: 'Group guidance',
          subtitle:
            'We guide the initiatives, you have time left for the rest.',
          description:
            "Bringing home seekers together takes time you don't have. CrowdBuilding recruits, matches and actively guides to an initiative that is on the same page and knows what it means to build together.",
        },
        kaartenbak: {
          badge: 'Plot issue',
          title: 'Kaartenbak',
          subtitle:
            'A proven issuance process, so you put your energy into the content, not the organization.',
          description:
            'CrowdBuilding takes over the issuance process from you. From recruitment and selection to the final allocation. Already successfully deployed in Utrecht and Rotterdam, and ready to use in your municipality.',
        },
        insight: {
          badge: 'Overview & network',
          title: 'Insight into every initiative',
          subtitle:
            'We bring the initiatives into focus, you determine the next step.',
          description:
            'With our local network and targeted campaigns, we ensure that the right people report. Via your own municipal dashboard, you can see live where each initiative stands and what the next step is, including reports.',
        },
        knowledge: {
          badge: 'Knowledge partners',
          title: 'Knowledge sharing',
          subtitle: 'We bring the expertise you need.',
          description:
            "Not every municipality has an expert in collective housing in-house - and they don't have to. Through our helpdesk, e-learning and a network of local and national experts, CrowdBuilding is always there for you, so you keep control without having to know everything yourself.",
        },
      },
      faq: {
        title: 'Frequently asked questions from municipalities:',
        subtitle:
          'Not a sales pitch, just the questions municipalities ask us — and the honest answers. Missing one? Let us know.',
        items: {
          time: {
            question: "Doesn't this take more time?",
            answer:
              'No. For a fixed annual fee, you get a working platform — including maintenance, security, updates and further development. No construction costs, no IT trajectory, no hidden additional costs. Having your own tool built and maintained quickly costs ten times as much in year one, plus the hours you put into it internally.',
          },
          self: {
            question: "Can't we do this ourselves?",
            answer:
              "Of course you can. But the question is whether you want to. We have already built this infrastructure, together with other municipalities and hundreds of initiative groups. You don't have to reinvent how to register initiatives, keep track of phases and communicate transparently. You join what is there — and only pay for the use.",
          },
          live: {
            question: 'How fast are we live?',
            answer:
              'Within a few weeks. The platform is already running. We set up your municipal page and profile, you sign the user agreement, and you are live. No development phase, no one-year pilot.',
          },
          safe: {
            question: 'Is it safe?\\nOur data is sensitive.',
            answer:
              'Yes. The platform meets the requirements that municipalities set for accessibility and privacy, and we work according to GIBIT 2023 — the standard for municipal IT procurement. For personal data, we act as a processor, with a separate processing agreement. You maintain control over your data.',
          },
          stop: {
            question: "What if we don't like it?",
            answer:
              "Then you stop. You choose the duration yourself: one year, three years, or one year with optional extension. Cancellation is possible in writing, with one month's notice before the end of the contract period. You can stop the municipal page in the meantime — we will then place a neutral message with a reference to alternatives. No lock-in.",
          },
        },
      },
      contact: {
        title: 'Schedule a non-binding consultation',
        description:
          'Curious what CrowdBuilding can do for your municipality? We would love to think along with you - without obligations.',
        buttonLabel: 'Schedule a conversation',
        people: {
          sascha: {
            role: 'Co-founder and partnerships lead',
          },
          freddie: {
            role: 'Partnerships',
          },
        },
      },
      planDemoButton: 'Schedule a demo',
    },
    landingPage: {
      title: 'Make your living dream a reality.',
      description:
        'Housing construction needs to be radically different. More sustainable, more social, and more affordable. Build together with your future neighbours.',
      searchPlaceholder: 'Search by name, municipality or province',
      searchButton: 'Search',
      modernAFrameHouse: 'Modern A-frame House',
      erfdelen: 'Land parcels',
      sharedLivingSpacesAndCommunityPlots:
        'Shared living spaces and community plots',
      meergeneratiewonen: 'Multi-generational living',
      multiGenerationalLivingCommunities:
        'Multi-generational living communities',
      whyCrowdBuilding: 'Why CrowdBuilding?',
      whyCrowdBuildingDescription:
        'Housing construction must be radically different: more sustainable, social and affordable. By building together with your future neighbors, you determine how you live, save costs and create a close-knit community.',
      signUpButton: 'Sign up',
      maintenanceMessage:
        'We are currently performing maintenance on our platform. Please check back shortly.',

      discoverSection: {
        title: 'Initiatives',
        subTitle:
          'Find or start an initiative that fits your housing dream and get in touch with others.',
        seeMore: 'See all',
        emptyTitle: 'No initiatives found',
      },
      housingFormsSection: {
        title: 'Popular living formats',
        subTitle:
          'How do you want to live? In a tiny house? Or is the region important to you? Find each other.',
        seeMore: 'See all',
        emptyTitle: 'No housing forms found',
      },
      aboutSection: {
        title: 'About CrowdBuilding',
        subTitle:
          'Collective building and living is realizing your ideal living place together with others. Design and build your own living environment together with a group, or find your place in an existing community. It can all be done. But how do you start? Read more in our KnowledgeHub.',
        seeMore: 'Read more',
        cta: [
          {
            title: 'Find others',
            subtitle:
              'Find or start an initiative and get in touch with each other.',
          },
          {
            title: 'Find a location',
            subtitle:
              'On CrowdBuilding you will find plots and buildings suitable for collective building projects.',
          },
          {
            title: 'Find experts',
            subtitle:
              'Find the right experts at every stage of your initiative. From architects to financing.',
          },
        ],
      },
      blogSection: {
        title: 'Stories',
        subTitle:
          'Many people have gone before you. Read how these collective builders approach it.',
        seeMore: 'See all',
      },
      statsAndCtaSection: {
        title: 'Every day new people and initiatives join. ',
        subTitle:
          'Every day people and initiatives take the next step towards realising their housing dream. Sign up for free and start today.',
        cta: [
          {
            title: 'Start an initiative',
          },
          {
            title: 'Sign up',
          },
        ],
        statistics: [
          {
            number: '8K+',
            subtitle: 'Users',
          },
          {
            number: '95+',
            subtitle: 'Locations',
          },
          {
            number: '170+',
            subtitle: 'Initiatives',
          },
          {
            number: '65+',
            subtitle: 'Experts',
          },
        ],
      },
      newsletterSection: {
        title: 'Sign up',
        subTitle: 'Start your housing dream or find others.',
        placeholder: 'Email address',
        successMessage: 'Thanks for subscribing!',
      },
    },
    discoverServiceProviders: {
      title: shared.experts,
      description:
        'From architects to process supervisors and from financial advisors to local support points: find the right help for every phase of your self-build initiative.',
      filters: 'Filters',
      removeFilters: 'Remove Filters',
      searchPlaceholder: 'Search for experts',
      emptyTitle: 'No service providers found',
      emptyDescription:
        "Try adjusting your search or filter criteria to find what you're looking for.",
      categories: {
        processSupervision: 'Process Supervision',
        architecture: 'Architecture',
        advice: 'Advice',
        financing: 'Financing',
        development: 'Development',
        construction: 'Construction',
        networks: 'Networks',
        supportPoint: 'Support Point',
      },
      filtersModal: {
        title: 'Filters',
        specialism: 'Specialism',
        type: 'Type',
        operatingArea: 'Operating Area',
        apply: 'Apply',
      },
    },
    messageComposeModal: {
      newMessage: 'New message',
      recipient: 'To',
      subject: 'Subject',
      message: 'Message',
      send: 'Send message',
    },
    socialShareModal: {
      title: 'Share this page',
      email: 'Email',
      x: 'X',
      facebook: 'Facebook',
      whatsapp: 'WhatsApp',
      copyLink: 'Copy link',
      copiedLink: 'Link copied!',
      close: 'Close',
    },
    serviceProviderPage: {
      overview: 'Overview',
      events: 'Agenda',
      initiatives: 'Initiatives',
      knowledgeHub: shared.knowledgeHub,
      current: 'Current',
      ourInitiatives: 'Our initiatives',
      ourInitiativesDescription: 'Join one of our collective initiatives.',
      developmentArea: 'Development area',
      concepts: 'Concepts',
      ourConcepts: 'Our concepts',
      address: 'Address',
      email: 'Email',
      phone: 'Phone number',
      website: 'Website',
      specializations: 'Specialized in',
      activeRegions: 'Working area',
      loading: shared.loading,
      notFound: 'Expert not found',
      noInitiativesTitle: 'Be the first',
      noInitiativesCta: 'Start initiative',
      noInitiativesDescription: 'Be the first, create your initiative',
    },
    serviceProviderConceptPage: {
      tabs: {
        overview: 'Overview',
        initiatives: shared.initiative.plural,
        discussion: 'Discussion',
      },
      offeredBy: 'Offered by',
      members: shared.members,
      loading: shared.loading,
      initiatives: shared.initiative.plural,
      initiativesDescription: 'Join one of the collective initiatives.',
    },
    footer: {
      slogan: 'The ultimate living place\nyou build together',
      info: 'Info',
      services: 'Services',
      joinIn: 'Join in',
      sections: {
        info: {
          howDoesItWork: 'How does it work?',
          contactUsLink: 'Contact us',
          knowledgeHub: 'Knowledge hub',
          storiesLink: 'Stories',
          blogAndNewsLink: 'Blog & News',
          events: 'Events',
          termsAndConditions: 'Terms and conditions',
          privacy: 'Privacy statement',
        },
        services: {
          initiatives: 'Initiatives',
          plots: 'Plots',
          housingForms: 'Living formats',
          experts: shared.experts,
          cpoDesks: 'CPO-desk in your region',
        },
        joinIn: {
          joinGroup: 'Register a group',
          applyForPlot: 'Apply for a plot',
          forExperts: 'For experts',
          forMunicipalities: 'For municipalities',
          joinUsLink: 'Work at CrowdBuilding',
        },
      },
    },
    mediaGallery: {
      allMedia: 'All media',
    },
    pageNames: {
      home: 'Home',
      initiatives: 'Initiatives',
      housingForms: 'Housing forms',
      plots: 'Plots',
      agenda: 'Agenda',
      serviceProviders: shared.experts,
      regions: 'Regions',
    },
    dashboardPage: {
      title: 'Dashboard',
    },
    initiativePage: {
      applyTooltip: 'Apply to join and get in touch',
      followTooltip: shared.followTooltip,
      membersTooltip: 'Online members of this initiative',
      unknownLocation: shared.unknownLocation,
      notSpecified: shared.notSpecified,
      apply: 'Apply to join',
      leave: 'Leave initiative',
      withdrawApplication: 'Withdraw application',
      follow: shared.follow,
      following: shared.following,
      share: 'Share',
      initiative: shared.initiative,
      follower: {
        singular: 'Follower',
        plural: 'Followers',
      },
      member: {
        singular: 'Member',
        plural: 'Members',
      },
      admin: {
        singular: 'Admin',
        plural: 'Admins',
      },
      overview: 'Overview',
      thread: 'Thread',
      events: 'Events',
      overviewTab: {
        whoDoWeLookFor: 'Who do we look for',
        searchArea: 'Search area',
        features: 'Features',
        contact: 'Contact information',
      },
      phases: phaseTranslations,
      modalApplyConfirmation:
        'Are you sure you want to apply to be the member of initiative {0}? Initiative admin will review your application',
      modalLeaveConfirmation: 'Are you sure you want to leave initiative {0}?',
      modalWithdrawConfirmation:
        'Are you sure you want to withdraw your membership application to initiative {0}?',
      modalApplyTitle: 'Apply to join',
      modalDefaultTitle: shared.attention,
      overviewFeaturesKeys: {
        location: 'Location',
        phase: 'Initiative phase',
        developmentForm: 'Development form',
        numberOfHouseholds: 'Number of households',
        livingEnvironment: 'Living environment',
        targetAudience: 'Target audience',
        tags: 'Tags',
        amenities: 'Amenities',
      },
      contactInformationKeys: {
        contactPerson: 'Contact person',
      },
      noEvents: 'No events linked.',
    },
    eventPage: {
      address: 'Address',
      openInLuma: 'Open event',
    },
    plotPage: {
      deadline: 'Deadline',
      officialOffering: 'CrowdBuilding registration',
      privateOffering: 'External registration',
      applicationClosesInLabel: 'Application closes in {0}d',
      numberOfUnitsLabel: 'Maximum homes {0}',
      applicationStatus: {
        applicationOpen: 'Application open',
        applicationClosed: 'Application closed',
        inPreparation: 'In preparation',
      },
      plotRegistryRequirementAlert:
        'Note! A {0} is required for this application.',
      plotRegistryRequirementAlertLinkText: 'plot registry registration',
      registerInitiative: 'Register initiative',
      follow: 'Interest list',
      share: 'Share',
      offeredBy: 'Offered by',
      initiative: {
        singular: 'Initiative',
        plural: 'Initiatives',
      },
      follower: {
        singular: 'Follower',
        plural: 'Followers',
      },
      interestListText: 'on the interest list',
      overview: 'Overview',
      applicationProcedure: 'Application procedure',
      documents: 'Documents',
      thread: 'Bulletin board',
      overviewTab: {
        info: 'Info',
        whatIsNext: "What's next",
        location: 'Location',
        plan: 'Planning',
        contact: 'Contact information',
        features: 'General',
      },
      overviewFeaturesKeys: {
        offerType: 'Offer type',
        buildingType: 'Building type',
        developmentForm: 'Development form',
        ownershipType: 'Ownership type',
        livingEnvironment: 'Living environment',
        numberOfUnits: 'Number of units',
      },
      contactInformationKeys: {
        providerType: 'Provider type',
        organization: 'Organization',
        contactPerson: 'Name',
        email: 'Email',
        website: 'Website',
      },
      threadTab: {
        postPlaceholder: 'Write your question here',
        noPostsTitle: 'This discussion has no messages yet.',
        noPostsDescription: 'Be the first to ask a question or make a call.',
      },
      modalCopy: {
        official:
          'Your interest in this plot becomes visible to other CrowdBuilders. They can send you a message. This way you have a chance to form an initiative together for this application.',
        nonOfficial:
          'Your interest in this plot becomes visible to other CrowdBuilders. They can send you a message. This way you have a chance to form an initiative together for this application.\n\nThe official application runs through the website of the plot provider.',
      },
      followModal: {
        title: 'Sign up Interest list',
        prompt: 'Do you want to sign up as initiative or individual?',
        asInitiative: 'As initiative',
        asIndividual: 'As individual',
        selectInitiative: 'Select an initiative',
      },
      unfollowModal: {
        title: 'Unsubscribe Interest list',
        prompt: 'What would you like to unsubscribe?',
        asInitiative: 'Initiative',
        asIndividual: 'Individual',
        selectInitiative: 'Select initiatives to unsubscribe',
      },
      sendMessage: 'Send message',
    },
    post: {
      like: 'Like',
      reply: 'Reply',
      oneLike: 'Like',
      manyLikes: 'Likes',
      oneReply: 'Reply',
      manyReplies: 'Replies',
      typeYourReply: 'Type your reply',
      loadMoreReplies: 'Load more replies',
      loadMoreComments: 'Load more comments',
    },
    profilePage: {
      bio: 'Bio',
      livingDream: 'Living dream',
      media: 'Media',
      connect: 'Make contact',
      placeOfResidence: 'Place of residence',
      initiatives: 'Initiatives',
      followedHousingForms: 'Follows Living formats',
      searchRegion: 'Searches in region',
      livingEnvironment: 'Living environment',
      interests: 'Interests',
      emptyProfileMessage: 'has not introduced themselves yet.',
    },
    regionPage: {
      managedBy: 'Managed by',
      pageTabTitle: {
        overview: '',
        discussion: 'Discussion in {0}',
        initiatives: 'Initiatives in {0}',
        current: 'News in {0}',
        locations: 'Locations in {0}',
        knowledgeHub: 'Knowledge hub of {0}',
        developmentAreas: 'Development areas in {0}',
        stepByStep: 'Step by step in {0}',
        subsidies: 'Subsidies in {0}',
        experts: 'Experts from {0}',
      },
      overview: 'Overview',
      discussion: 'Discussion',
      initiatives: 'Initiatives',
      knowledgeHub: shared.knowledgeHub,
      initiativesIn: 'Initiatives in {0} ({1})',
      locationsIn: 'Locations in {0} ({1})',
      current: 'Current',
      developmentAreas: 'Development areas',
      stepByStep: 'Step by step',
      downloadStepByStepPdf: 'Download PDF',
      locations: 'Locations',
      subsidies: 'Subsidies',
      experts: shared.experts,
      more: 'More',
      noInitiativesTitle: 'Be the first',
      noInitiativesCta: 'Start initiative',
      noInitiativesDescription: 'Be the first, create your initiative',
      noLocationsTitle: 'No matching locations yet',
      noLocationsDescription: 'Register a building or plot yourself.',
      nutshell: {
        inAnutshell: ' in a nutshell',
      },
      events: 'Agenda',
      news: 'News',
      latestDiscussions: 'Latest Discussions',
      popularInitiatives: 'Popular Initiatives',
      popularHousingFormsIn: 'Popular living formats in',
      ambassadors: shared.ambassadors,
      networksAndSupportGroupsIn: 'Networks and Support Groups in',
      serviceProvidersIn: 'Experts in',
      topicCommunitiesIn: 'Organisations in',
      municipalities: 'Municipalities',
      lockedMunicipalityHeader: 'Municipality {0} is not yet online',
      lockedMunicipalityFollowed: shared.lockedPageFollowed,
      lockedMunicipalityBodyFollowed: shared.lockedPageFollowedText,
      lockedMunicipalityBody:
        'We are working to make this municipality available on CrowdBuilding. Show your interest and be the first to know when {0} goes online.',
      lockedProvinceHeader: 'Province {0} is not yet online',
      lockedProvinceFollowed: shared.lockedPageFollowed,
      lockedProvinceBodyFollowed: shared.lockedPageFollowedText,
      lockedProvinceBody:
        'We are working to make this province available on CrowdBuilding. Show your interest and be the first to know when {0} goes online.',
      followThePage: 'Follow the page',
      pageFollowed: 'Followed',
      sorting: {
        newestFirst: 'Newest first',
        oldestFirst: 'Oldest first',
        popular: 'Popular first',
      },
      filters: {
        title: 'Filters',
        phase: 'Phase',
        lookingForMembers: 'Looking for members',
        developmentForm: 'Development form',
        apply: 'Apply',
        back: 'Back',
        yes: 'Yes',
        no: 'No',
        noPreference: 'No preference',
      },
    },
    nav: {
      find: 'Find',
      findDescription: 'Find initiatives and living groups that fit you',
      start: 'Start',
      learn: 'Learn',
      aboutUs: 'About',
      logIn: 'Log in',
      signUp: 'Sign up',
      logOut: 'Log out',
      dashboardHome: 'Overview',
      profile: 'Profile',
      megaMenu: {
        findMenu: {
          initiatives: {
            label: 'Find initiatives',
            description: 'View collective self-build groups and join.',
          },
          livingGroups: {
            label: 'Find living groups',
            description: 'Find existing living groups looking for residents.',
          },
          plots: {
            label: 'Find locations',
            description:
              'Find plots or buildings to realize your living dream.',
          },
          region: {
            label: 'Search in your region',
            description: 'View initiatives, plots and get in touch.',
          },
          housingForms: {
            label: 'Find housing forms',
            description:
              'Tiny houses or self-build street? Follow your favorite housing forms.',
          },
          experts: {
            label: 'Find expert',
            description: 'From process supervisors to architects.',
          },
        },
        startMenu: {
          citizens: {
            label: 'For initiators',
            description:
              'Start a new initiative or register an existing initiative and find interested people.',
            links: {
              startInitiative: 'Start an initiative on CrowdBuilding',
              registerProject: 'Register existing project/housing group',
            },
          },
          companies: {
            label: 'For developers',
            description:
              'Are you a professional party looking for enthusiastic residents for a project? Start here.',
          },
        },
        learnMenu: {
          events: {
            label: 'Agenda',
            description:
              'Discover all events by CrowdBuilding and our partners.',
          },
          knowledgeHub: {
            label: 'Knowledge Hub',
            description:
              'Here you will find all the information you need to make your living dream a reality.',
            links: {
              whatCanIDo: 'What can I do on CrowdBuilding?',
              createAccount: 'How do I create an account?',
              startInitiative: 'How do I start an initiative myself?',
            },
          },
          elearning: {
            label: 'E-learning',
            description:
              'Learn step by step everything about collective self-building with our free e-learnings.',
          },
          stories: {
            label: 'Stories',
            description: 'Read how others successfully build together.',
          },
        },
        aboutUsMenu: {
          about: {
            label: 'About CrowdBuilding',
            description:
              'How we contribute to a fair and sustainable housing market.',
            links: {
              stewardOwned: 'Steward-owned',
              joinUs: 'Careers',
              contact: 'Contact',
            },
          },
          legal: {
            label: 'Legal',
            description: 'General terms and conditions and privacy policy.',
          },
          partner: {
            label: 'Become a Partner',
            links: {
              municipalities: 'Municipalities',
              provinces: 'Provinces',
              experts: 'Experts',
            },
          },
        },
        shared: {
          knowledgeHub: 'Knowledge Hub',
          howCrowdBuildingWorksLink: 'How does CrowdBuilding work?',
          howCrowdBuildingWorksDescription:
            'Join an initiative and form\na building group',
          whatIsCollectiveSelfConstruction: 'What is collective self-build?',
          isCollectiveLivingAffordable: 'Is collective living affordable?',
          storiesLink: 'Stories',
          storiesDescription:
            'Successfully building together?\nSee how they did it!',
          governmentSectionLink: 'Government desk',
          governmentSectionDescription:
            'View policy, building plots,\ninitiatives and subsidies per region.',
          relevantNow: 'Relevant now',
        },
      },
    },
    dashboard: {
      yourInitiatives: 'Your initiatives',
      noteworthyInitiatives: 'Noteworthy initiatives',
      nav: {
        home: 'Home',
        messages: 'Messages',
        initiatives: 'Initiatives',
        profile: 'Profile',
        preferences: 'Preferences',
        following: shared.following,
      },
      pageContentEditor: {
        addBlock: 'Add content block',
        removeBlock: 'Remove block',
        moveUp: 'Move up',
        moveDown: 'Move down',
        titleLabel: 'Title',
        titlePlaceholder: 'Section title',
        bodyLabel: 'Body',
        bodyPlaceholder:
          'Write the section content; use the toolbar for bold, lists, and more.',
        reset: 'Reset',
        richTextBold: 'Bold',
        richTextItalic: 'Italic',
        richTextStrikethrough: 'Strikethrough',
        richTextBulletList: 'Bullet list',
        richTextNumberedList: 'Numbered list',
        richTextLink: 'Link',
        richTextLinkUrlPlaceholder: 'https://...',
        richTextLinkConfirm: 'Add link',
        richTextLinkCancel: 'Cancel',
        richTextLinkRemove: 'Remove link',
      },
      home: {
        title: 'Hello, {0}',
        welcome: 'Welcome to your dashboard',
        updatesPlaceholder:
          'From your dashboard you can manage your messages, initiatives and profile, and discover new initiatives.\nSoon you will also see updates from initiatives and pages you follow.',
        KnowledgeHub: 'Knowledge Hub',
        KnowledgeHubCardTitle: 'New here?',
        KnowledgeHubCardDescription:
          'Learn more about collective building and living in our knowledge hub.',
        DiscoverMore: 'Discover',
        DiscoverCardTitle: 'Looking for a house?',
        DiscoverCardDescription:
          'Find a living group looking for residents, or join an initiative that is still in the making.',
        StartInitiative: 'Start initiative',
        StartInitiativeCardTitle: 'Start your own initiative?',
        StartInitiativeCardDescription:
          'Start your own initiative and find interested people, plots and more.',
        StoriesTitle: 'Let yourself be inspired by\n others',
      },
      messages: {
        messages: shared.messages,
        inbox: 'Inbox',
        openMessages: 'Open messages',
        peopleToMessageTitle: 'People to message',
        peopleToMessageDescription:
          "Note: you can only message to admins of the initiative you're following or are member of.",
        allMessages: 'All messages',
        followedInitiatives: 'Initiatives I follow',
        from: 'from',
        sendMessage: 'Send message',
        newMessage: 'New Message',
        subject: 'Subject:',
        noSubject: 'No subject',
        typeYourReply: 'Type your reply...',
        noMessagesPlaceholder: 'No messages',
        emptyStateTitle: 'Your messages',
        emptyStateSubtitle:
          'Here you will find messages you have sent or received. Send a message to an initiative administrator to get started.',
        messageSent: 'Your message has been sent',
        loading: shared.loading,
        selectRecipients: 'Select recipients',
        addRecipients: 'Add recipients',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        numberOfMembersLabel: "You've got {0}",
        back: shared.back,
        done: 'Done',
        members: shared.members,
        followers: shared.followers,
        admins: shared.admins,
        interestList: 'Interest list',
        sentMessages: 'Sent',
        showMore: 'Show more',
        showLess: 'Show less',
        deletedProfile: 'This account has been deleted',
      },
      profile: {
        title: 'Profile',
        profileTooltip:
          'Once you follow an initiative or location, you apply for the interest list or respond to a discussion, others will see your profile and can contact you by sending a message through CrowdBuilding.',
        bio: 'Bio',
        bioEditHint:
          'Tell other users about yourself. A well-written bio helps others see whether you are a good match.',
        pictures: 'Pictures',
        media: 'Media',
        about: 'About',
        ageCategory: 'Age category',
        location: 'Location',
        numberOfAdults: 'Number of adults',
        numberOfChildren: 'Number of children',
        searchRegion: 'Search region',
        housingForm: 'Housing form',
        interests: 'Interests',
        fullName: 'Name and Last Name',
        nameErrorMessage: 'Please, specify your full name',
        yourRegions: 'Your search regions',
        selectRegion: 'Select a search region',
        yourHousingForms: 'Your housing forms',
        selectHousingForm: 'Select a housing form',
        yourInterests: 'Your interests',
        selectInterest: 'Select an interest',
        profileChangedSavedToast: 'Your profile was updated.',
        imageUploadHint:
          'Upload photos that show who you are and how you want to live.',
        imageUploadAlert:
          'Make sure files are in .jpeg format and not larger than 500KB',
        deleteProfileTitle: 'Delete account',
        deleteProfileConfirmation:
          'If you delete your account, all your data will be lost. If you have initiatives where you are the only admin, these will also be deleted. This action cannot be undone.',
        cancel: shared.cancel,
        confirm: 'Delete my account',
      },
      preferences: {
        title: 'Preferences',
        notificationSettings: 'Notification settings',
        livingSituationTitle: 'Living situation',
        livingSituationDescription:
          'All data from this field is NOT visible to other members but helps us to find you a better match.',
        housingType: 'Housing type',
        ownershipType: 'Desired ownership type',
        purchaseBudget: shared.purchaseBudget,
        rentalBudget: shared.rentalBudget,
        spaceSize: 'Space size',
        involvement: 'Involvement',
        houisngTypeOptions: {}, // Now fetched from database
        ownershipOptions: {}, // Now fetched from database
        spaceSizeOptions: {}, // Now fetched from database
        involvementOptions: {}, // Now fetched from database
        updateEmailsTitle: 'Update emails',
        updateEmailsSubtitle:
          'Receive two emails per month with a short update on plots, initiatives, stories and events.',
        importantNotificationsTitle: 'Important notifications',
        importantNotificationsSubtitle:
          'Important notifications about initiatives, housing forms and regions you follow. Think of new messages, comments in the Discussion tab and more.',
        monthlyNewsletterTitle: 'Monthly newsletter',
        monthlyNewsletterSubtitle:
          'Monthly the latest extensive news about CrowdBuilding, featured initiatives, opportunities, events and more.',
        crowdBuildingIntroductionTitle: 'CrowdBuilding introduction',
        crowdBuildingIntroductionSubtitle:
          'Email series about how you can use CrowdBuilding.',
        regionalNotificationsTitle: 'Provinces and municipalities I follow',
        regionalNotificationsSubtitle:
          'Updates about news, available subsidies, the plot registry and popular discussions.',
        initiativesNotificationsTitle: 'Initiatives I follow',
        initiativesNotificationsSubtitle:
          'Updates about popular bulletin board conversations, new events and posts from the initiative lead',
        houusingFormsNotificationsTitle: 'Living formats updates',
        houusingFormsNotificationsSubtitle:
          'Updates from the living formats you’re following. ',
        crowdBuildingUpdatesNotificationsTitle: 'Crowdbuilding updates',
        crowdBuildingUpdatesNotificationsSubtitle:
          'Platform updates such as new features.',
        crowdBuildingNewsNotificationsTitle: 'News emails from Crowdbuilding',
        crowdBuildingNewsNotificationsSubtitle:
          'Handpicked news that relate to the self building situation in the Netherlands.',
        notificationFrequencyOptions: notificationFrequencyTranslation,
        profileSettingsTitle: 'Account settings',
      },
      followed: {
        title: 'Followed',
        tabs: {
          following: 'Following',
          interestList: 'Interest List',
        },
        initiatives: 'Initiatives',
        regions: 'Regions',
        housingForms: 'Housing forms',
        plots: 'Plots',
        unfollow: 'Unfollow',
        municipality: 'Municipality',
        province: 'Province',
        youFollowNoInitiatives: 'You follow no initiatives',
        youFollowNoRegions: 'You follow no regions',
        youFollowNoHousingForms: 'You follow no housing forms',
        youFollowNoPlots: 'You follow no plots',
        discoverInitiatives: 'Discover initiatives',
        discoverRegions: 'Discover regions',
        discoverHousingForms: 'Discover housing forms',
      },
      initiative: {
        sideBar: {
          communityTools: 'Community tools',
          manage: 'Manage',
          about: 'About',
          messaging: 'Messaging',
          surveys: 'Surveys',
          pinBoard: 'Pin board',
          people: 'People',
        },
        common: {
          myInitiatives: 'My initiatives',
          loading: shared.loading,
          unnamedInitiative: 'Unnamed initiative',
          unknownDevelopmentForm: 'Unknown',
        },
        home: {
          noInitiativesPlaceholder:
            'You don\'t have any initiatives at the moment, start one ',
          startInitiative: 'Start an initiative',
          membersLabel: 'Members',
          followersLabel: 'Followers',
          articlesTitle: 'Useful articles',
          unnamedInitiative: 'Unnamed initiative',
          articlesSubtitle:
            'Don\'t know where to start with your initiative or whether it’s for you? Our articles got you covered.',
          initiativeDraft: 'Draft',
        },
        view: {
          developmentForm: 'Development form',
          housingForms: shared.housingForms,
          targetGroups: 'Target groups',
          interests: 'Interests',
          initiativeNameMinLength: 'Must be longer than 5 characters',
          nameEmptyLabel: 'Name not specified',
          sloganEmptyLabel: 'Slogan not specified',
          visionEmptyLabel: 'Vision not specified',
          photosEmptyLabel: 'Photos not added yet',
          finishOnboarding: 'Finish onboarding',
          pageContentEmpty:
            'No extra sections yet. These appear on your public initiative page below your vision.',
          deleteButton: 'Delete initiative',
          deleteConfirmDescription:
            'Are you sure you want to delete "{0}"? This action cannot be undone.',
          deleteSuccess: 'Initiative deleted',
          confirm: 'Delete my initiative',
          cancel: 'Cancel',
        },
        people: {
          loading: shared.loading,
          people: 'People',
          members: shared.members,
          followers: shared.followers,
          admins: shared.admins,
          requests: 'Requests',
          addedOn: 'Added on {0}',
          followingSince: 'Following since {0}',
          appliedOn: 'Applied on {0}',
          makeFollower: 'Move to followers',
          makeMember: 'Move to members',
          makeAdmin: 'Make an admin',
          removeFromProject: 'Remove from the initiative',
          participantStatusChanged: 'Participant status changed',
        },
        creation: {
          closeModalTitle: 'Confirm exist',
          closeModalContent:
            'Are you sure you want to leave?\nAll your changes will be saved.',
          createInitiative: 'Create an initiative',
          back: shared.back,
          next: 'Next',
          done: 'I am done',
          closeTheForm: 'Close this form',
          initiativePhaseNames: initiativePhaseNameTranslation,
          initiativePhaseDescriptions: initiativePhaseDescriptionTranslation,
          creationStepTitles: initiativeCreationStepTitleTranslation,
          creationStepDescriptions:
            initiativeCreationStepDescriptionTranslation,
          nameLabel: 'Initiative name',
          namePlaceholder: 'Name',
          sloganLabel: 'Initiative slogan',
          sloganPlaceholder: 'Slogan',
          imagesLabel: 'Select images',
          imagesSubtitle: 'You have to upload at least one image.',
          imagesInfoAlert:
            'Make sure files are in .jpeg format and not larger than 500KB.',
          visionSummaryLabel: 'Summary of living dream/vision',
          visionSummaryPlaceholder:
            'Briefly describe your idea in two or three sentences. This will appear as a summary at the top of your page.',
          developmentForm: 'Development form',
          targetGroups: 'Target groups',
          housingForms: shared.housingForms,
          interests: 'Interests',
          selectOne: 'Select one',
          selectOneOrMore: 'Select one or more',
          areYouLookingForMembers: 'Are you looking for members right now?',
          lookingForMembersTitle: 'Who do you look for? ',
          lookingForMembersSubtitle:
            'Think about what types of people, how many, etc.',
          lookingForMembersPlaceholder: 'Description of you target members',
          numberOfHomes: 'Number of homes',
          projectSize: 'Project size',
          purchaseBudget: shared.purchaseBudget,
          rentalBudget: shared.rentalBudget,
          numberOfHomesOptions: humberOfHomesTranslation,
          plotUnderOption: 'Plot under option?',
          notUnderOptionButInMind: 'Not yet but I have one in mind',
          address: 'Address',
          permit: 'Building permit',
          financingRequirementsConstruction:
            'Financing requirements construction',
          financingRequirementsPlanning: 'Financing requirements planning',
          kvkRegistration: 'Registered with KVK',
          contactPersonFirstName: 'Contact person first name',
          contactPersonLastName: 'Contact person last name',
          contactPersonEmailAdress: 'Contact person email address',
          contactPersonPhoneNumber: 'Contact person phone number',
          customAmenities: 'Custom amenities',
          addCustomAmenity: 'Add custom amenity',
          amenityNamePlaceholder: 'Amenity name',
          addOther: 'Other',
          save: 'Save',
          cancel: shared.cancel,
          customAmenityAdded: 'Amenity added',
          eLearningCardTitle: 'Learn about building and living',
          eLearningCardDescription:
            'Explore our e-learnings on collective building and living.',
          eLearningCardLinkLabel: 'Go to e-learning',
          knowledgeHubCardTitle: 'Read more in our knowledge hub',
          knowledgeHubCardDescription:
            'Read more about collective building and living.',
          knowledgeHubCardLinkLabel: 'Go to knowledge hub',
          pageContentTitle: 'Describe your full housing vision',
          pageContentSubtitle:
            'A clear housing vision helps you find other members. [Read more](https://crowdbuilding.com/kennishub/je-account-project?slug=tips-voor-een-goede-initiatiefpagina) about creating a strong housing vision. You can continue editing your housing vision in your dashboard.',
          pageContentPlaceholders: {
            mainBlock: {
              title: 'For example: Who we are',
              body: 'Who are you, and what makes this initiative special? Consider: your values, the region and what drives you. Keep it to 3 or 4 sentences.\nAdjust formatting and order with the toolbar below.',
            },
            visionBlock: {
              title: 'For example: Our vision',
              body: 'How do you want to live? Consider: the number of homes, types of homes, and whether you rent or buy. Keep it to 3 or 4 sentences.',
            },
            detailsBlock: {
              title: 'For example: Location and planning',
              body: 'Where do you want to build, and when? Consider: the region, the phase you are in and what you are still looking for. Keep it to 3 or 4 sentences.',
            },
          },
        },
      },
    },
    plotRegistry: {
      welcome: {
        title: 'Welcome to the plot registry',
        description:
          'Here you can read what the plot registry is and what benefits it offers you.',
        selectMunicipality: 'Choose your municipality/area',
        municipality: 'Municipality',
      },
      regionInfo: {
        stepsTitle:
          'Make sure you have completed the following steps before the registration process starts.',
        downloadDocument: 'Download document',
      },
      selectInitiative: {
        stepLabel: 'Step 1 of 3',
        title:
          'Select the initiative you want to register for the plot registry',
        subtitle: 'You need to be logged in to select an initiative.',
        noInitiativesTitle: 'No initiatives found',
        noInitiativesDescription:
          'You are not an owner or admin of any initiative. Create an initiative first or request admin access.',
      },
      uploadDocuments: {
        stepLabel: 'Step 2 of 3',
        title: 'Upload the required documents',
        description:
          'These documents will be shared with the municipality of {municipalityName}. They determine the final approval for the plot registry.',
        warningBold: 'Note:',
        warningText:
          'After submitting these documents, it is no longer possible to make changes.',
        uploadButton: 'Upload here',
        consent:
          'I agree that my data will be shared with the municipality of {municipalityName}.',
        uploadSuccess: 'Document uploaded',
        deleteSuccess: 'Document removed',
      },
      confirmation: {
        congratulations: 'Congratulations!',
        title: 'The documents have been submitted!',
        subtitle:
          'You will receive a confirmation of the submission via e-mail.',
        step1Title: 'Interview with municipality',
        step1Description:
          'The municipality will invite your initiative for an interview in the short term.',
        step2Title: 'Correction and supplementation',
        step2Description:
          'The municipality may ask you to correct or supplement any incomplete information.',
        step3Title: 'Municipality decision',
        step3Description:
          'The municipality of {municipalityName} will assess whether your initiative is admitted to the plot registry.',
        step4Title: 'Plot registry admission',
        step4Description:
          'Upon approval, your initiative will officially be part of the plot registry of the municipality of {municipalityName} and you can apply for building plots.',
      },
    },
    error: {
      notFoundTitle: 'Oops! This page is not found.',
      notFoundMessage:
        'Maybe a typo in the address bar? Go back to our homepage or use the menu.',
      imageAlt: 'Page not found',
    },
    form: {
      validation: {
        required: 'This field is required',
        minLength: 'Must be at least {0} characters',
        maxLength: 'Must be at most {0} characters',
        min: 'Must be at least {0}',
        max: 'Must be at most {0}',
        invalidEmail: 'Must be a valid email address',
        invalidUrl: 'Must be a valid URL',
        invalidFormat: 'Invalid format',
        mustBeNumber: 'Must be a number',
        mustBeInteger: 'Must be a whole number',
      },
      submissionResponse: {
        success: 'Form submitted successfully',
        fail: 'Form submission failed',
      },
    },
    steunpuntAmsterdam: {
      hero: {
        title: 'Living together starts here',
        subtitle:
          'Find a housing group, start your own, or just learn more — we will help you along the way.',
        locationTag: 'Amsterdam',
        categoryTag: 'Housing groups 55+',
      },
      landing: {
        aboutUs: {
          title: 'About us',
          text: 'The Steunpunt Collectief Wonen Amsterdam is an initiative by !WOON, in collaboration with Woonsaem, OWA 50+ and the municipality of Amsterdam. We inform Amsterdammers about different forms of collective living, support new initiatives with their first steps, and connect home seekers with existing housing initiatives. We help you online and offline. Visit our consultation hour for personal advice, or join one of our events.',
        },
        agenda: {
          title: 'Agenda',
        },
        whyCollectiveLiving: {
          title: 'Why collective living?',
          cards: {
            independentAtHome: {
              title: 'Stay independent at home longer',
              text: 'Living together makes it easier to take care of yourself. With neighbours who help when needed, on your own terms.',
            },
            livingTogether: {
              title: 'Living together, living life',
              text: 'Discover how collective living can give you a more pleasant, social, and affordable home.',
            },
            homeFit: {
              title: 'A home that suits you',
              text: 'Your life changes, your housing wishes too. Collective living gives you the space to have a say in what your home looks like.',
            },
            neverAlone: {
              title: 'Never alone at the table again',
              text: 'Collective living means neighbours who look out for you. A cup of coffee, a chat in the garden — just because you can.',
            },
          },
        },
        lookingForHousing: {
          title: 'I am looking for housing in Amsterdam',
          text: 'The Steunpunt Collective Living is opening in a few weeks. Sign up now and stay informed.',
        },
        whySteunpunt: {
          title: 'Why Steunpunt Collective Living?',
          text: 'The Steunpunt Collective Living helps Amsterdammers who want to live together. Whether you are looking for a housing group, want to register one, or just want to know more about collective living — we can help.',
        },
        forWhom: {
          title: 'Who is the Steunpunt for?',
          text: 'The Steunpunt Collective Living helps Amsterdammers who want to live together. Whether you are looking for a housing group, want to register one, or just want to know more about collective living — we can help.',
        },
        residentStories: {
          title: 'Stories from residents',
        },
        registerGroup: {
          title: 'I want to register my housing group',
          text: 'Let other Amsterdammers discover your housing group',
        },
        questions: {
          title: 'Questions?',
          text: 'Freddie and Mirjam are happy to help',
          buttonLabel: 'Make an appointment',
        },
      },
      nav: {
        about: 'About Steunpunt',
        knowledgeHub: 'Knowledge Hub',
        agenda: 'Agenda',
        contact: 'Contact',
      },
      ourPartners: {
        title: 'Our partners',
      },
      footer: {
        description:
          'From first idea to key handover. We help Amsterdammers who want to live together.',
        contactHeader: 'CONTACT',
        platformHeader: 'PLATFORM',
        dataVia: 'Data via',
      },
      signup: {
        triggerLabel: 'Sign up',
        modalTitle: 'Sign up',
        signupTypeLabel:
          'First choose whether you are signing up as an individual or a group',
        tabIndividual: 'Individual',
        tabGroup: 'Group',
      },
      signupIndividual: {
        triggerLabel: 'Sign up',
        modalTitle: 'Sign up',
        firstNameLabel: 'First name',
        firstNamePlaceholder: 'Your first name',
        lastNameLabel: 'Last name',
        lastNamePlaceholder: 'Your last name',
        middlePartLabel: 'Middle name / addition',
        middlePartPlaceholder: 'e.g. van der',
        emailLabel: 'Email address',
        emailPlaceholder: 'name@example.nl',
        ageCategoryLabel: 'Age category',
        ageCategoryLoadingLabel: 'Loading age categories...',
        ageCategoryPlaceholder: 'Choose an age category',
        locationLabel: 'Where in Amsterdam would you like to live?',
        termsLabel:
          'Steunpunt Collective Living Amsterdam runs on the CrowdBuilding platform. By signing up you agree to the privacy policy of CrowdBuilding B.V.',
        successTitle: 'Thank you for signing up',
        successText:
          'We will let you know when Steunpunt Collective Living opens.',
        successToast: 'Your registration has been sent.',
        errorToast: 'Your registration could not be sent.',
        validation: {
          firstNameRequired: 'Please enter your first name',
          lastNameRequired: 'Please enter your last name',
          emailInvalid: 'Please enter a valid email address',
          ageCategoryRequired: 'Please choose an age category',
          locationRequired: 'Please enter your location',
          termsRequired: 'You must agree to the terms',
        },
      },
      signupGroup: {
        triggerLabel: 'Register your housing group',
        modalTitle: 'Sign up',
        firstNameLabel: 'First name',
        firstNamePlaceholder: 'Your first name',
        lastNameLabel: 'Last name',
        lastNamePlaceholder: 'Your last name',
        middlePartLabel: 'Middle name / addition',
        middlePartPlaceholder: 'e.g. van der',
        emailLabel: 'Email address',
        emailPlaceholder: 'name@example.nl',
        groupNameLabel: 'Name of your group',
        groupNamePlaceholder: 'Enter the name of your group',
        locationLabel: 'Where in Amsterdam is your group located?',
        commentsLabel: 'Other comments',
        termsLabel:
          'Steunpunt Collective Living Amsterdam runs on the CrowdBuilding platform. By signing up you agree to the privacy policy of CrowdBuilding B.V.',
        successTitle: 'Thank you for signing up',
        successText:
          'We will let you know when Steunpunt Collective Living opens.',
        successToast: 'Your registration has been sent.',
        errorToast: 'Your registration could not be sent.',
        validation: {
          firstNameRequired: 'Please enter your first name',
          lastNameRequired: 'Please enter your last name',
          emailInvalid: 'Please enter a valid email address',
          groupNameRequired: 'Please enter the name of your group',
          locationRequired: 'Please enter your location',
          termsRequired: 'You must agree to the terms',
        },
      },
    },
  },
  cass: {
    layout: {
      headerSubtitle: 'Crowdbuilding Admin & Support Services',
    },
    analytics: {
      pageTitle: 'User analytics',
      pageDescription:
        'User activity metrics based on login, visit, and signup data.',
      loading: 'Loading analytics...',
      timeframe: 'Timeframe',
      exportCsv: 'Export CSV',
      exportCsvSuccess: 'User data export started',
      exportCsvError: 'Failed to export user data',
      timeframes: {
        today: 'Today',
        yesterday: 'Yesterday',
        last7days: 'Last 7 days',
        weekToDate: 'Week to date',
        last30days: 'Last 30 days',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        last90days: 'Last 90 days',
        quarterToDate: 'Quarter to date',
        thisYear: 'This year (Jan - Today)',
        lastCalendarYear: 'Last calendar year',
      },
      kpi: {
        totalUsers: 'Total users',
        mau: 'Monthly active users',
        mauSubtitle: 'Active this month',
        dau: 'Daily active users',
        dauSubtitle: 'Active today',
        inactive: 'Inactive users',
        percentActive: '% active',
      },
      charts: {
        mauTitle: 'Monthly active users',
        mauSubtitle: 'New signups and returning active users by month',
        dauTitle: 'Daily active users',
        dauSubtitle: 'Users last active per day in selected timeframe',
        newSignups: 'New signups',
        returningActive: 'Returning active',
        activeUsers: 'Active users',
        mauTooltip:
          'Stacked area chart of monthly active users, split into new signups (registered that month) and returning active users (registered in a prior month). Activity is based on last login or last visit date.',
        dauTooltip:
          'Bar chart of daily active users. Each bar shows users whose last login or last visit date falls on that specific day within the selected timeframe.',
        signupSourcesTitle: 'Signup sources',
        signupSourcesSubtitle: 'Top signup channels for new registrations in selected timeframe',
        signupSourcesTooltip:
          'Horizontal bar chart of the top 10 signup sources (utm_source or equivalent) for users who registered within the selected timeframe. Empty or missing sources are grouped as unknown.',
        signupSourceUnknown: 'Unknown / direct',
        signupSourceLabel: 'Source',
        signupSourceCount: 'Signups',
      },
    },
    initiativeAnalytics: {
      sectionTitle: 'Initiative analytics',
      sectionDescription:
        'Popularity, admin activity, and messaging metrics for initiatives.',
      loading: 'Loading initiative analytics...',
      timeframe: 'Timeframe',
      exportCsv: 'Export initiatives CSV',
      exportCsvSuccess: 'Initiative data export started',
      exportCsvError: 'Failed to export initiative data',
      timeframes: {
        today: 'Today',
        yesterday: 'Yesterday',
        last7days: 'Last 7 days',
        weekToDate: 'Week to date',
        last30days: 'Last 30 days',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        last90days: 'Last 90 days',
        quarterToDate: 'Quarter to date',
        thisYear: 'This year (Jan - Today)',
        lastCalendarYear: 'Last calendar year',
      },
      kpi: {
        totalInitiatives: 'Total initiatives',
        mai: 'Monthly active initiatives',
        maiSubtitle: 'Admin activity this month',
        newFollowers: 'New followers',
        newFollowersSubtitle: 'In selected timeframe',
        newMembers: 'New members',
        newMembersSubtitle: 'In selected timeframe',
        pendingMembers: 'Pending applications',
        pendingMembersSubtitle: 'New applications in selected timeframe',
        avgAdminResponse: 'Avg admin response',
        avgAdminResponseSubtitle: 'Time to reply to messages',
        avgAdminResponseUnit: 'min',
        totalMessages: 'Messages sent',
        totalMessagesSubtitle: 'In selected timeframe',
        replyRate: 'Reply rate',
        replyRateSubtitle: 'Channels with reciprocal conversation',
        replyRateUnit: '%',
      },
      charts: {
        paceTitle: 'Followers & members pace',
        paceSubtitle: 'New followers and members by month',
        newFollowers: 'New followers',
        newMembers: 'New members',
        maiTitle: 'Monthly active initiatives',
        maiSubtitle: 'Initiatives with admin activity by month',
        activeInitiatives: 'Active initiatives',
        followersTitle: 'New followers',
        followersSubtitle: 'New followers added by month',
        membersTitle: 'New members',
        membersSubtitle: 'New members added by month',
        adminResponseTitle: 'Admin response time',
        adminResponseSubtitle: 'Average admin response time by month (minutes)',
        avgAdminResponseMinutes: 'Avg response (min)',
        maiTooltip:
          'Area chart of monthly active initiatives. An initiative is active if any of its admins logged in or visited the platform during that month, after becoming an admin.',
        followersTooltip:
          'Area chart of new followers added per month. A user is counted when their follower-since date falls within that month across all initiatives.',
        membersTooltip:
          'Area chart of new members added per month. A user is counted when their member-since date falls within that month across all initiatives.',
        adminResponseTooltip:
          'Bar chart of average admin response time in minutes per month. Calculated as the average time from a non-admin message to the first admin reply, across all initiative channels.',
        pendingTitle: 'Pending applications',
        pendingSubtitle: 'New member applications awaiting review by month',
        pendingTooltip:
          'Area chart of new member applications per month. Counts users with applicant role whose application date falls within each month.',
        pendingMembers: 'Pending applications',
        messagesTitle: 'Messages sent',
        messagesSubtitle: 'Total message box messages by month',
        messagesTooltip:
          'Bar chart of total messages sent across all initiative channels per month within the selected timeframe.',
        messagesLabel: 'Messages',
      },
    },
    sidebar: {
      brand: 'CASS',
      beta: 'BETA',
      logoAlt: 'CrowdBuilding',
      logout: 'Logout',
      language: 'Language',
      languageEn: 'English',
      languageNl: 'Dutch',
      nav: {
        start: {
          label: 'Start',
          dashboard: 'Dashboard',
          analytics: 'Analytics',
        },
        tools: {
          label: 'Tools',
          builder: 'Query Builder',
        },
        home: {
          label: 'Home',
          initiatives: 'Initiatives',
          plots: 'Plots',
          topicCommunities: 'Topic Communities',
          serviceProviders: 'Service Providers',
          serviceProvidersConcepts: 'Service Providers Concepts',
          users: 'Users',
          regions: 'Regions',
          municipalities: 'Municipalities',
          localities: 'Localities',
          spotlight: 'Spotlight',
          threads: 'Discussions',
          businessProfiles: 'Business Profiles',
        },
        content: {
          label: 'Content',
          blogs: 'Blogs',
          news: 'News',
          stories: 'Stories',
          events: 'Events',
          landingMarketingStats: 'Landing Marketing Stats',
          knowledgeHub: 'Knowledge Hub',
          pageSeo: 'Page SEO',
        },
        processes: {
          label: 'Processes',
          plotRegistry: 'Plot Registry',
        },
        settings: {
          label: 'Settings',
          ageCategories: 'Age Categories',
          amenities: 'Amenities',
          buildingTypes: 'Building Types',
          businessProfileTypes: 'Business Profile Types',
          buyBudgets: 'Buy Budgets',
          rentBudgets: 'Rent Budgets',
          developmentForms: 'Development Forms',
          houseSurfaces: 'House Surfaces',
          housingForms: 'Housing Forms',
          housingFormTypes: 'Housing Form Types',
          interests: 'Interests',
          involvement: 'Involvement',
          livingEnvironments: 'Living Environments',
          offerTypes: 'Offer Types',
          ownershipSituations: 'Ownership Situations',
          phases: 'Phases',
          serviceProviderSpecializations: 'Service Provider Specializations',
          targetAudiences: 'Target Audiences',
          platformTenants: 'Platform Tenants',
        },
        cassUserManagement: {
          label: 'CASS User Management',
          adminUsers: 'Admin Users',
        },
      },
    },
  },
} as const

export default en
